import classNames from "classnames";
import { FC } from "react";
import SvgCrossCircle from "../icons/CrossCircle";
import styles from "./RedCross.module.css";
type RedCrossProps = {
  className?: string;
};

const RedCross: FC<RedCrossProps> = ({ className }) => {
  return <SvgCrossCircle className={classNames(styles.cross, className)} />;
};

export default RedCross;
